// src/components/application/application.types.ts
var backgroundValues = ["none", "glass-vertical", "glass-horizontal", "glass-angled"];

export {
  backgroundValues
};
